import { makeAutoObservable } from 'mobx'
import { logger } from 'shared/lib'
import type { Inbox } from 'entities/Inbox/model/Inbox'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { CallApi } from 'entities/Call'
import { Attachment } from 'entities/Attachment/model/Attachment'
import { type ISmartCallFlowGreetingAudioStepBlockArgs } from 'entities/SmartCall/api/types'
import { RinglessMessageFieldStore } from 'widgets/MessageFormFields/RinglessMessageField'
import { MediaLibraryVariant } from 'widgets/MediaLibrary/types/types'

export class GreetingAudioBlockStore {
  ringlessMessageFieldStore: RinglessMessageFieldStore
  constructor(
    private _entities: IEntitiesStore,
    readonly parent: { inbox: Inbox | null },
    readonly errorMessage: string,
    args?: ISmartCallFlowGreetingAudioStepBlockArgs
  ) {
    this.ringlessMessageFieldStore = new RinglessMessageFieldStore(this._entities, {
      ttsGroup: 'voicemail',
      clearParentError: () => {
        this.setError('')
      },
      onAddAudio: async (file: File, onAddAttachment) => {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('name', file.name)
        formData.append('type', 'open_hours')
        formData.append('is_make_active', '0')
        if (this.parent.inbox?.id) {
          try {
            const { data } = await CallApi.uploadVoicemailGreeting(formData, this.parent.inbox?.id)
            const attachment = new Attachment({
              responseVoicemailGreetings: data,
            })
            onAddAttachment(attachment)
            this._entities.organizationStore.addVoicemailGreetingsAttachments(attachment)
          } catch (e) {
            logger.error(e)
          }
        }
      },
      mediaLibraryConfiguration: {
        mediaLibraryVariant: MediaLibraryVariant.AudioSelect,
        fetchAttachmentList: async (term = '') =>
          this._entities.organizationStore.voicemailGreetingsAttachments.filter((item) =>
            item.name?.toLowerCase().includes(term.toLowerCase())
          ),
      },
    })
    if (args?.audioUrl) {
      this.ringlessMessageFieldStore.init({
        url: args.audioUrl,
      })
    }
    makeAutoObservable(this)
  }

  get args(): ISmartCallFlowGreetingAudioStepBlockArgs {
    return {
      audioUrl: this.ringlessMessageFieldStore.attachment?.source || '',
    }
  }

  validate = () => {
    const isValid = !!this.args?.audioUrl
    if (!isValid) {
      this.setError(this.errorMessage)
    } else {
      this.setError('')
    }

    return isValid
  }

  get error() {
    return this.ringlessMessageFieldStore.error
  }
  setError = (value: string) => {
    this.ringlessMessageFieldStore.setError(value)
  }
}
